export default __webpack_public_path__ + "static/media/PVI_Insurance_card.3a7336ae.jpg";